// Module
var code = "<p>Making <strong>Interest Bill</strong> payments prevents accrued interest from capitalizing (being added to your principal balance) before you start receiving regular monthly bills.</p> ";
// Exports
export default code;